import { Card, formattedCurrency, withStyles } from 'vopay';
import { Title, DetailsRows } from 'UI';
import { useTranslation } from 'react-i18next';
import type { UserRoles } from 'vopay';
import styleSheet from './ApproverCard.module.scss';
import LinkedAccountsBadge from '../LinkedAccountsBadge';
import { useClientData } from '@/providers/ClientData.provider';

const cn = withStyles(styleSheet);

interface ApproverCardProps {
  username: string;
  paymentRails: UserRoles[];
  linkedAccounts?: string[];
}

const ApproverCard = ({ username, paymentRails, linkedAccounts = [] }: ApproverCardProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Configuration.Roles.Approvers' });
  const {
    response: { subAccountPermissions },
  } = useClientData();

  const seen = new Set<string>();
  const details = paymentRails
    .filter((rail) => {
      const key = `${rail.TransactionType}-${rail.MaxAmount}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((rail) => ({
      label: rail.TransactionType,
      value: rail.MaxAmount ? `${formattedCurrency(rail.MaxAmount)}` : t('noLimit', { defaultValue: 'No Limit' }),
    }));

  return (
    <Card className={cn('card')} hoverEffect={false}>
      <div className={cn('usernameRow')}>
        <Title level="5" className={cn('username')}>
          {username}
        </Title>
        {subAccountPermissions && <LinkedAccountsBadge accounts={linkedAccounts} />}
      </div>
      <div className={cn('railsHeader')}>
        <Title level="6">{t('paymentRailsLabel', { defaultValue: 'Payment Rails' })}</Title>
        <Title level="6">{t('maximumApprovalAmountLabel', { defaultValue: 'Maximum Approval Amount' })}</Title>
      </div>
      <DetailsRows details={details} />
    </Card>
  );
};

export default ApproverCard;
